import { ref as d, computed as k, onMounted as y, createElementBlock as a, openBlock as l, normalizeClass as o, createCommentVNode as n, createBlock as q, toDisplayString as r, createElementVNode as g } from "vue";
import v from "../../link/link.vue.js";
import { themeProp as w } from "../../../composables/useTheme.js";
import { screenProp as x } from "../../../utils/utilsScreen.js";
/* empty css                  */
import p from "../../../_virtual/_plugin-vue_export-helper.js";
const b = {
  key: 2,
  class: "ds-margin-top-24 ds-md-display-flex ds-quote-simple__info"
}, I = ["src", "alt", "loading"], j = /* @__PURE__ */ Object.assign({
  name: "DsQuoteSimple"
}, {
  __name: "quote-simple",
  props: {
    ...w,
    ...x,
    logo: {
      type: Object,
      default: null
    },
    text: {
      type: String,
      required: !0
    },
    author: {
      type: String,
      default: ""
    },
    extraInfo: {
      type: String,
      default: ""
    },
    link: {
      type: Object,
      default: null
    },
    appendDoubleQuotes: {
      type: Boolean,
      default: !1
    },
    animate: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const f = e, i = d(null), u = d(!1), m = d(null), h = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
      // Trigger when 10% of the element is in view
    }, s = k(() => f.animate && u.value);
    return y(() => {
      m.value = new IntersectionObserver((t) => {
        t.forEach((c) => {
          c.isIntersecting && (u.value = !0);
        });
      }, h), i.value && m.value.observe(i.value);
    }), (t, c) => (l(), a("blockquote", {
      ref_key: "quoteElement",
      ref: i,
      class: o(["ds-quote-simple", { "ds-quote-simple--animated": s.value }])
    }, [
      e.appendDoubleQuotes ? (l(), a("q", {
        key: 0,
        class: o(["ds-quote-simple__text", {
          "ds-color-white": t.theme === "dark" || t.theme === "dark-grey",
          "ds-text-xlarge": t.screen !== "small",
          "ds-text-large": t.screen === "small",
          "ds-quote-simple__text--animated": s.value
        }]),
        "data-j-quote": ""
      }, r(e.text), 3)) : (l(), a("p", {
        key: 1,
        class: o(["ds-quote-simple__text", {
          "ds-color-white": t.theme === "dark" || t.theme === "dark-grey",
          "ds-text-xlarge": t.screen !== "small",
          "ds-text-large": t.screen === "small",
          "ds-quote-simple__text--animated": s.value
        }]),
        "data-j-quote": ""
      }, r(e.text), 3)),
      e.logo || e.author || e.extraInfo ? (l(), a("div", b, [
        e.logo ? (l(), a("div", {
          key: 0,
          class: o([[`ds-quote-simple__logo--${t.theme}`, { "ds-quote-simple__logo--spacing": !!(e.author || e.extraInfo) }], "ds-quote-simple__logo--container ds-md-margin-right-24"])
        }, [
          g("img", {
            class: "ds-quote-simple__logo--img",
            src: e.logo.src,
            alt: e.logo.alt,
            loading: e.logo.lazy ? "lazy" : "eager",
            "data-j-logo": ""
          }, null, 8, I)
        ], 2)) : n("", !0),
        g("div", null, [
          e.author ? (l(), a("p", {
            key: 0,
            class: o([{ "ds-color-white": t.theme === "dark" || t.theme === "dark-grey" }, "ds-text ds-font-weight-bold"]),
            "data-j-author": ""
          }, r(e.author), 3)) : n("", !0),
          e.extraInfo ? (l(), a("p", {
            key: 1,
            class: o([{ "ds-color-white": t.theme === "dark" || t.theme === "dark-grey" }, "ds-text"]),
            "data-j-extrainfo": ""
          }, r(e.extraInfo), 3)) : n("", !0)
        ])
      ])) : n("", !0),
      e.link ? (l(), q(v, {
        key: 3,
        "tracking-data": { "component-name": t.$options.name, text: e.link.title },
        url: e.link.url,
        "lazy-url-endpoint": e.link.lazyUrlEndpoint,
        "open-in-new-window": e.link.openInNewWindow,
        nuxt: e.link.nuxt,
        content: e.link.title,
        "icon-right": { category: "arrows", name: "chevron-right-small" },
        color: "green",
        class: "ds-margin-top-24",
        "data-j-link": ""
      }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content"])) : n("", !0)
    ], 2));
  }
}), Q = /* @__PURE__ */ p(j, [["__scopeId", "data-v-1fa05406"]]);
export {
  Q as default
};
